import React from 'react'
import { Link } from 'react-router'
import EditIcon from '../../img/icons/general-icons/icon_edit.png'

export default class LinkUpdateUser extends React.Component {
  render () {
    //  console.log(this.props.data)//[this.props.rowData.Id - 1])
    var url = 'user/' + this.props.data
    return (
      <Link to={url}><img src={EditIcon}/></Link>
    )
  }
}

/* Validate Props */
LinkUpdateUser.propTypes = {
  rowData: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/SearchUser/LinkUpdateUser.js